import { SharedPortfolio } from '@unistocks/features/portfolios/shared-portfolio';
import { useSharedPortfoliosGetSharedPortfolioQuery } from '@unistocks/proxy/axios-client/SharedPortfoliosQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { HasId } from '@unistocks/types/has-id';
import { useFocusEffect, useLocalSearchParams, useNavigation } from 'expo-router';
import Head from 'expo-router/head';
import { useCallback } from 'react';

export default function SharedPortfoliosScreen() {
  const navigation = useNavigation();
  const { id } = useLocalSearchParams<HasId>();

  const { data: portfolio, isSuccess } = useSharedPortfoliosGetSharedPortfolioQuery(id);

  useFocusEffect(
    useCallback(() => {
      if (portfolio) {
        navigation.setOptions({ title: portfolio.name });
      }
    }, [navigation, portfolio])
  );

  let title = t('::Portfolio');
  if (isSuccess) {
    title = `${portfolio.name} | ${title}`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <SharedPortfolio id={id} />
    </>
  );
}
